<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.dynamic')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumbTitle() }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-wrapper">
      <div class="news-main">
        <div class="news-title">
          <h1>{{ newsInfo.news_title }}</h1>
          <p>
            <span>{{ newsInfo.created_at }}</span>
            作者：{{ newsInfo.news_author }}
          </p>
        </div>
        <div class="news-content" v-html="newsInfo.news_content"></div>
      </div>
      <div class="news-sidebar">
        <ul class="news-sidebar-list">
          <li
            v-for="item in newsList2.slice(0, 3)"
            :key="item.news_id"
            @click="goNewsInfo(item.news_id)"
          >
            <h4>{{ item.news_title }}</h4>
            <p>{{ item.created_at }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
export default {
  data() {
    return {
      ID: this.$route.query.ID,
      category: this.$route.query.category,
      newsInfo: {},
      newsList: [],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    newsList2() {
      return this.localeNewsList(this.locale);
    },
  },
  watch: {
    locale(newS, old) {
      if (newS != old) {
        this.$router.go(-1);
      }
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getNewsInfo();
    this.getNewsList();
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getNewsInfo() {
      const getNewsInfo = await www.getNewsInfo({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        news_id: this.ID,
      });
      this.newsInfo = getNewsInfo;
    },
    async getNewsList() {
      const getNewsList = await www.getNewsList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        category: this.category,
        status: 'publish',
      });
      this.newsList = getNewsList.data;
    },
    localeNewsList(locale) {
      return _.filter(this.newsList, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },
    breadcrumbTitle() {
      if (this.category == '1') {
        return this.getTitle('header.notice');
      } else if (this.category == '2') {
        return this.getTitle('header.recentDynamic');
      } else if (this.category == '3') {
        return this.getTitle('header.news');
      }
    },
    goNewsInfo(ID) {
      this.ID = ID;
      routerTo.toNewsInfo(this.$router, false, { ID: ID });
      this.getNewsInfo();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner {
  background-image: url(../assets/images/banner-2.jpg);
}
.news-wrapper {
  display: flex;
  width: 1100px;
  margin: 20px auto 20px;
  padding: 40px 40px;
  border-radius: 12px;
  color: #191b26;
  font-size: 16px;
  line-height: 32px;
  text-align: left;
  background: #fff;
  .news-main {
    width: 640px;
    margin-right: 60px;
    .news-title {
      margin-bottom: 20px;
      text-align: center;
      h1 {
        margin: 0;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px dashed #eee;
        color: #191b26;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
      }
      p {
        margin: 0;
        color: #9e9e9e;
        font-size: 14px;
        text-align: center;
        span {
          margin-right: 12px;
        }
      }
    }
    .news-content /deep/ p {
      margin-bottom: 24px;
      text-align: justify;
    }
    .news-content /deep/ p.image {
      line-height: 0;
      text-align: center;
    }
    .news-content /deep/ img {
      max-width: 100%;
      margin: 0 auto;
    }
  }
  .news-sidebar {
    width: 320px;
    .news-sidebar-list {
      list-style: none;
      li {
        padding: 10px 0;
        border-top: 1px dashed #eee;
        h4 {
          margin-bottom: 6px;
          color: #191b26;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          cursor: pointer;
        }
        p {
          color: #9e9e9e;
          font-size: 14px;
          line-height: 20px;
        }
      }
      li:first-child {
        border-top: none;
      }
    }
  }
}
</style>
